"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoInitDocumentBootstrapping = exports.initDocumentBootstrapping = void 0;
const tslib_1 = require("tslib");
require("lodash/fp/throttle");
const process_1 = tslib_1.__importDefault(require("process"));
const deviceUtils_1 = require("./deviceUtils");
const colorScheme_1 = require("./colorScheme");
const version_json_1 = tslib_1.__importDefault(require("../version.json"));
const uikitVersion = version_json_1.default.version;
// Note: using import.meta.env.DEV does not work here due to backward compatibility with webpack and jest setups
const isProdEnv = () => process_1.default.env.NODE_ENV === 'production' || location.protocol.startsWith('https');
const isTestEnv = () => process_1.default.env.NODE_ENV === 'test';
const isLocalhost = () => { var _a; return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === 'localhost'; };
const debug = (message) => !isTestEnv() && console.debug(message);
const log = (message) => !isTestEnv() && console.log(message);
const logStyled = (message) => console.log('%c%s', 'color: #697a8b;', message);
const printPoweredByRIO = () => {
    logStyled('- - - - - - - - - - - - - - - - - -');
    const message = [`RIO UIKIT Version ${uikitVersion}\nhttps://uikit.developers.rio.cloud`];
    if (isProdEnv() && !(0, deviceUtils_1.inIframe)()) {
        message.push('\n\n You are a Developer? RIO is hiring! | https://rio.cloud/en/career');
    }
    logStyled(message.join(''));
    logStyled('- - - - - - - - - - - - - - - - - -');
};
const checkForReleaseVersion = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (!isProdEnv()) {
        return;
    }
    const remoteVersionsListUrl = 'https://uikit.developers.rio.cloud/versionsList.json';
    try {
        const response = yield fetch(remoteVersionsListUrl, { method: 'get' });
        // console.log(response);
        const data = yield response.json();
        if (data.latest_release !== uikitVersion) {
            console.log(`🆕 UIKIT version ${data.latest_release} is the latest released version! Your are using ${uikitVersion}`);
        }
    }
    catch (error) {
        // console.warn(error);
        console.warn(`Failed to fetch versionsList from ${remoteVersionsListUrl}`);
    }
});
const checkMatchingUkitVersions = () => {
    const cssLinks = [...document.querySelectorAll('link[rel="stylesheet"]')];
    cssLinks.forEach(cssLink => {
        const { href } = cssLink;
        if (href.includes('uikit.developers.rio.cloud')) {
            const [, uikitVersionCSS] = new URL(href).pathname.split('/');
            if (!href.includes(uikitVersion)) {
                console.warn([
                    'You are using different UIKIT JS and CSS versions.\n',
                    `Your current JS version is ${uikitVersion} and `,
                    `your current CSS version is ${uikitVersionCSS}.\n`,
                    'If this is not on purpose, please fix it. Otherwise, this may lead to UI bugs.',
                ].join(''));
            }
        }
        else if (href.includes('cdn.rio.cloud/libs/rio-uikit')) {
            console.error('You are still using an old "cdn.rio.cloud" css import. This will lead to mayor UI bugs!');
        }
    });
};
const experimentalLoadUikitCSS = () => {
    var _a;
    if ((_a = document.title) === null || _a === void 0 ? void 0 : _a.includes('UIKIT Demo')) {
        return;
    }
    // check for existing uikit CSS in document head
    debug('Check for UIKIT CSS in document head');
    const hasUikitCssLink = !!document.head.querySelector('link[href*="rio-uikit.css"]') ||
        !!document.head.querySelector('link[href*="rio-uikit-core.css"]');
    const isUikitDemoPage = !!document.head.querySelector('style[data-vite-dev-id*="uikit.less"]');
    const hasUikitThemeCssLink = !!document.head.querySelector('link[href*="man-uikit.css"]') ||
        !!document.head.querySelector('link[href*="vw-uikit.css"]') ||
        !!document.head.querySelector('link[href*="scania-uikit.css"]') ||
        !!document.head.querySelector('link[href*="rio-website.css"]');
    if (hasUikitCssLink || isUikitDemoPage || hasUikitThemeCssLink) {
        debug('Existing UIKIT CSS found in document head');
        return;
    }
    // If nothing is set, add a link tag to fetch the CSS from the UIKIT CDN.
    // Note: there is no way to differentiate between core + responsive or full CSS
    debug('No UIKIT CSS found. Add link tag to document head');
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `https://uikit.developers.rio.cloud/${uikitVersion}/rio-uikit.css`;
    link.onload = () => console.debug(`Loaded CSS link ${link.href}`);
    link.onerror = () => console.error(`Failed to load ${link.href}`);
    document.head.appendChild(link);
};
const initDocumentBootstrapping = (document) => {
    if (!document || !document.documentElement) {
        return;
    }
    if (!isTestEnv()) {
        console.group('UIKIT');
        console.log(`Init document bootstrapping for ${document.location.href}`);
    }
    experimentalLoadUikitCSS();
    const html = document.documentElement;
    if (!window.CSS || !window.CSS.supports || !window.CSS.supports('gap: 1px')) {
        html.classList.add('css-no-gap');
    }
    if ((0, deviceUtils_1.inIframe)()) {
        html.classList.add('window-iframe');
    }
    if (!isTestEnv()) {
        (0, colorScheme_1.getColorScheme)();
        (0, colorScheme_1.listenForSchemeChange)();
        printPoweredByRIO();
        checkForReleaseVersion();
        checkMatchingUkitVersions();
        console.groupEnd();
    }
};
exports.initDocumentBootstrapping = initDocumentBootstrapping;
exports.autoInitDocumentBootstrapping = (document => (0, exports.initDocumentBootstrapping)(document))(document);
